<template>
  <page-column>
    <page-header></page-header>
    <page-row>
      <!-- <page-aside></page-aside> -->
      <page-main>
        <!-- <test></test> -->
        
      </page-main>
    </page-row>
    <page-footer></page-footer>
  </page-column>
</template>

<script>
import Test from '@project2/components/Test.vue'

export default {
  components: {
    Test
  },
  provide () {
    return {
      mainReload: this.mainReload,
      isRouterAlive: () => this.isRouterAlive
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    mainReload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/workspace/views/home/Home.vue